import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TelephonyProvider } from '../../providers/telephony/telephony.provider';
import { TelephonyStateService } from '../../providers/telephony/telephony.state.service';
import { AgentStatusService } from '../../services/agentstatus.service';
import { CallService } from '../../services/call.service';
import { CampaignService } from '../../services/campaign.service';
import { DialpadService } from '../../services/dialpad.service';
import { NavService } from '../../services/nav.service';
import { ToastService } from '../../services/toast/toast.service';
import { Constants } from '@app/constants';
import { FormGroup, Validators } from '@angular/forms';
import { ConnectionService } from '../../services/network.service';
import { Subscription } from 'rxjs';
import { naturalSensitiveSort } from '../../utils/sort';
import momentTimezone from 'moment-timezone';
import moment from 'moment';

@Component({
  selector: 'app-on-going-call',
  templateUrl: './on-going-call.component.html',
  styleUrls: ['./on-going-call.component.scss'],
})
export class OnGoingCallComponent implements OnInit, OnDestroy {
  @Input() draggable: boolean = true;
  viewDisposition: boolean = false;
  dragPosition = { x: 0, y: 0 };
  isFloaterCollapsed = true;
  isMiniFloater = false;
  hasInternetAccess = false;
  addons = [];
  private internetSubscription = new Subscription();
  private metaDataSubscription = new Subscription();
  
  public callbackConfig = {
    minDate: new Date(),
    timeZones: [
      { name: 'Eastern', value: 'EST' },
      { name: 'Central', value: 'CT' },
      { name: 'Mountain', value: 'MT' },
      { name: 'Pacific', value: 'PT' }
    ],
    hours: Array.from({ length: 24 }, (_, i) => i + 1),
    minutes: Array.from({ length: 4 }, (_, i) =>
      (i * 15).toString().padStart(2, '0')
    ),
    // minutes: Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0')),
  };
  constructor(
    public telephonyState: TelephonyStateService,
    public telephony: TelephonyProvider,
    public navService: NavService,
    public dialpadService: DialpadService,
    public callService: CallService,
    public campaignService: CampaignService,
    public statusService: AgentStatusService,
    private toastService: ToastService,
    private internetService: ConnectionService
  ) { }

  ngOnInit(): void {
    this.internetSubscription.add(
      this.internetService.stateChanged$.subscribe((state) => {
        this.hasInternetAccess = state.hasInternetAccess;
      })
    );
    this.metaDataSubscription.add(this.campaignService.$metaDataChange.subscribe((metadata: any) => {
      this.addons = naturalSensitiveSort(metadata.Addons).asc('Name' as any) as any;
    }));
     console.log('callbackConfig', this.callbackConfig.minDate);
  }
  ngOnDestroy(): void {
    this.internetSubscription.unsubscribe();
    this.metaDataSubscription.unsubscribe();
  }

  hangupCall() {
    if (!this.hasInternetAccess) {
      this.toastService.error('No internet connection available. Please check your internet connection and try again');
      return;
    }
    if (this.statusService.currentStatus.FriendlyName == Constants.STATUSES.Hold.FriendlyName) {
      this.toastService.info('Cannot end the call, Please resume first');
      return;
    }

    this.campaignService.applyFormTouch();



    let validSale = this.campaignService.isFormValid(this.campaignService.salesForm);
    let valid = false;
    switch (this.campaignService.stepperIndex) {
      case 0:
        valid = this.campaignService.isFormValid(this.campaignService.greetingForm);
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          this.telephony.voice.endCall(null, true);
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
        }
        else {
          this.telephony.voice.endCall(null, false);
          if (!this.pkAddonsToCheck()) return;
        }
        break;
      case 1:
      case 2:
        valid =
          this.campaignService.isFormValid(this.campaignService.greetingForm) &&
          this.campaignService.isFormValid(this.campaignService.addressForm);
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          this.telephony.voice.endCall(null, true);
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
        } else {
          this.telephony.voice.endCall(null, false);
          if (!this.pkAddonsToCheck()) return;
        }
        break;
      case 3:
        valid =
          this.campaignService.isFormValid(this.campaignService.greetingForm) &&
          this.campaignService.isFormValid(this.campaignService.addressForm) &&
          validSale;
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          if (!this.chatTfnCheck()) return;
          this.telephony.voice.endCall(null, true);
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
        } else {
          this.telephony.voice.endCall(null, false);
          if (!this.campaignService.dispositionForm.valid && this.campaignService.showChatTfnTextbox) {
            if (!this.campaignService.dispositionForm.controls['chatTfn'].valid) {
              this.toastService.info('Chat TFN is required. Please enter a valid Chat TFN from the dialpad');
            }
          }
          if (!this.pkAddonsToCheck()) return;        
        }
        break;
    }
  }
  muteCall() {
    if (this.dialpadService.muteUnmuteEnabled) this.telephony.voice.muteUnMuteCall(null);
  }
  holdCall() {
    if (this.dialpadService.holdResumeEnabled)
      if (this.dialpadService.holdResumeEnabled) this.telephony.voice.holdCall(null, this.telephonyState.onHold);
  }
  disposeCall() {
    if (!this.hasInternetAccess) {
      this.toastService.error('No internet connection available. Please check your internet connection and try again');
      return;
    }
    this.campaignService.logCampaignScripts();
    this.campaignService.navigateToCampaignRoute();
    if (this.statusService.currentStatus.FriendlyName == Constants.STATUSES.Hold.FriendlyName) {
      this.toastService.info('Cannot end the call, Please resume first');
      return;
    }

    this.campaignService.applyFormTouch();

    if (!this.pkAddonsToCheck()) return;


    let valid = false;
    let validSale = this.campaignService.isFormValid(this.campaignService.salesForm);
    if (!validSale && this.callBackTimeZoneValidation()) {
      return
    }
    switch (this.campaignService.stepperIndex) {
      case 0:
        valid = this.campaignService.isFormValid(this.campaignService.greetingForm);
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          this.telephony.voice.endCall(null, true);
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
          return;
        }
        break;
      case 1:
      case 2:
        valid =
          this.campaignService.isFormValid(this.campaignService.greetingForm) &&
          this.campaignService.isFormValid(this.campaignService.addressForm);
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          this.telephony.voice.endCall(null, true);
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
          return;
        }
        break;
      case 3:
        valid =
          this.campaignService.isFormValid(this.campaignService.greetingForm) &&
          this.campaignService.isFormValid(this.campaignService.addressForm) &&
          validSale;
        if (valid && validSale) {
          if (!this.addonsCheck()) return;
          if (!this.chatTfnCheck()) return;
          this.telephony.voice.endCall(null, true);
          this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
          return;
        }
        break;
    }
    if (valid && this.campaignService.dispositionForm.valid) {
      this.telephony.voice.endCall(null, true);
      this.telephony.voice.disposeCall(null, this.statusService.lastStatusBeforeCall.FriendlyName);
    }
    else {
      if (!this.campaignService.dispositionForm.valid && this.campaignService.showChatTfnTextbox) {
        if (!this.campaignService.dispositionForm.controls['chatTfn'].valid) {
          this.toastService.info('Chat TFN is required and should be a valid phone number');
        }
      }
    }
    // console.log(new Date().toLocaleString() + '  ➤  dispose forms greeting ==> ', this.campaignService.greetingForm);
  }

  resetPosition() {
    this.dragPosition = { x: 0, y: 0 };
  }

  toggleFloaterCollapse() {
    this.isFloaterCollapsed = !this.isFloaterCollapsed;
  }

  toggleMiniFloater() {
    this.isMiniFloater = !this.isMiniFloater;
  }
  addonsCheck() {
    if (this.campaignService.isFECallAndFEAddonsNotSelected()) {
      this.toastService.info('Please select FE addons first');
      return false;
    }
    //* PK Addons Validation Check
    if (this.campaignService.isPKCallAndIsSaleAndPKAddonsNotSelected()) {
      this.toastService.info('Please select Home Security addons first');
      return false;
    }
    //* AutoPay Addons Validation Check
    if (this.campaignService.isPortmoreCallAndIsSaleAndAutoPayAddonsNotSelected()) {
      this.toastService.info('Please select AUTO-PAY addons first');
      return false;
    }

    const serviceableProviderAddon = this.campaignService.isSaleAndBDServiceableProvidersAddonsNotSelected();
    if (!serviceableProviderAddon.isSelected) {
      serviceableProviderAddon.warning.forEach(e => {
        this.toastService.info(e);
      });
      return false;
    }

    return true;
  }
  pkAddonsToCheck() {
    //* PK Addons Validation Check
    if (this.campaignService.isPKCallAndIsSaleAndPKAddonsNotSelected()) {
      this.toastService.info('Please select Home Security addons first');
      return false;
    }
    return true;
  }
  chatTfnCheck() {
    if (this.campaignService.isChatSkillCall && this.campaignService.isFormValid(this.campaignService.salesForm)) {
      this.campaignService.salesForm.controls['chatTfn'].clearValidators();
      this.campaignService.salesForm.controls['chatTfn'].setValidators([Validators.required, this.campaignService.phoneValidator]);
      this.campaignService.salesForm.controls['chatTfn'].updateValueAndValidity();

      if (this.campaignService.salesForm.controls['chatTfn'].valid) {
        return true;
      };
      this.toastService.info('Chat TFN is required and should be a valid phone number');
      return false;
    }
    return true;
  }

  private callBackTimeZoneValidation() {
    const isCallBack = this.campaignService.dispositionCallbackSelection === 'Callback Scheduled';
    if (isCallBack) {
      const callbackTimezone = this.campaignService.dispositionForm.get('callbackTimezone')?.value;
      const callbackDate = this.campaignService.dispositionForm.get('callbackDate')?.value;
      const callbackHour = this.campaignService.dispositionForm.get('callbackHour')?.value;
      const callbackMins = this.campaignService.dispositionForm.get('callbackMins')?.value;
      // callbackDate = new Date(callbackDate)
      const fields = [
        [callbackTimezone, 'timezone'],
        [callbackDate, 'date'],
        [callbackHour, 'hour'],
        [callbackMins, 'minutes'],
      ] as const;

      for (const [value, name] of fields) {
        if (!value) {
          this.toastService.info(`Please select ${name}`);
          return false;
        }
      }
      console.log(`${callbackDate.getDate()} ${callbackDate.getMonth() + 1} ${callbackDate.getFullYear()} ${callbackHour}:${callbackMins}`)
      const day = callbackDate.getDate();
      const month = callbackDate.getMonth();
      const year = callbackDate.getFullYear();
      const hour = Number(callbackHour);
      const minute = callbackMins;

      const timeZone: Record<string, string> = {
        'EST': 'America/New_York',
        'CT': 'America/Chicago',
        'MT': 'America/Denver',
        'PT': 'America/Los_Angeles'
      };
      console.log(timeZone[callbackTimezone])
      const formatted = moment.tz({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: +minute
      }, timeZone[callbackTimezone]).format('MMMM Do YYYY, h:mm:ss a');
      const callbackTime = this.getTimeZoneDate(formatted, callbackTimezone);
      const currentTime = this.getTimeZoneMOment(callbackTimezone);
      if (callbackTime.isBefore(currentTime)) {
        this.toastService.error("Validation Error: Selected time is in the past for timezone:", callbackTimezone);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  private getTimeZoneMOment(timeZone: string): momentTimezone.Moment {
    switch (timeZone) {
      case 'EST':
        return momentTimezone().tz('America/New_York');
      case 'CT':
        return momentTimezone().tz('America/Chicago');
      case 'MT':
        return momentTimezone().tz('America/Denver');
      case 'PT':
        return momentTimezone().tz('America/Los_Angeles');
      default:
        return momentTimezone();
    }
  };

  private getTimeZoneDate(datetime: string, timeZone: string): momentTimezone.Moment {
    switch (timeZone) {
      case 'EST':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/New_York');
      case 'CT':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/Chicago').tz('America/New_York');
      case 'MT':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/Denver').tz('America/New_York');
      case 'PT':
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/Los_Angeles').tz('America/New_York');
      default:
        return momentTimezone.tz(datetime, 'MMMM Do YYYY, h:mm:ss a', 'America/New_York');
    }
  };

  public updateMinDate(timeZoneKey: string): void {
    const TIMEZONE_MAP: Record<string, string> = {
      'EST': 'America/New_York',
      'CT': 'America/Chicago',
      'MT': 'America/Denver',
      'PT': 'America/Los_Angeles'
    };
    const tzName = TIMEZONE_MAP[timeZoneKey];
    if (!tzName) return;

    // Get current date/time in selected timezone
    const tzMoment = momentTimezone().tz(tzName);

    // Set minDate to start-of-day in selected timezone (maps to local JS Date for p-calendar)
    const newMinDate = new Date(
      tzMoment.year(),
      tzMoment.month(),
      tzMoment.date(),
      0, 0, 0, 0
    );

    this.callbackConfig.minDate = newMinDate;
    console.log('callbackConfig', this.callbackConfig.minDate);
    // Reset selected callbackDate if it falls before the new minDate
    const currentDateControl = this.campaignService.dispositionForm.get('callbackDate');
    if (currentDateControl?.value && new Date(currentDateControl.value) < newMinDate) {
      currentDateControl.setValue(null);
    }
  }
}
